<template>
  <div v-if="show" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-content" @click.stop>
      <h2 class="modal-title">Reactivate Subscription</h2>
      <p class="modal-message">
        Are you sure you want to reactivate your premium subscription? 
      </p>
      <div class="info-box">
        <p><span class="info-icon">👑</span> Premium features will be available.</p>
        <p><span class="info-icon">💳</span> You'll be charged the subscription fee of $9.90/month.</p>
        <p v-if="nextPaymentDate"><span class="info-icon">⏱️</span> Your next payment will be on&nbsp;<strong>{{ formattedNextPayment }}</strong>.</p>
        <p><span class="info-icon">🔄</span> You can cancel your subscription at any time.</p>
      </div>

      <div class="modal-actions">
        <button class="cancel-btn" @click="handleCancel">Cancel</button>
        <button class="confirm-btn" @click="handleConfirm">Reactivate Subscription</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResubscribeModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    nextPaymentDate: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    formattedNextPayment() {
      if (!this.nextPaymentDate) return '';
      const date = new Date(this.nextPaymentDate);
      if (isNaN(date)) return this.nextPaymentDate;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleOverlayClick() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.modal-message {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.info-box {
  background-color: #f8f9fa;
  border-left: 4px solid var(--primary-color, #BA7BA1);
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
}

.info-box p {
  margin: 0.5rem 0;
  color: #555;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
}

.info-icon {
  margin-right: 0.5rem;
}

strong {
  font-weight: 600;
  color: #333;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid #ccc;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #f5f5f5;
}

.confirm-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  background: var(--primary-color, #BA7BA1);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn:hover {
  background: #c88ab2;
}
</style> 